import { createContext, useCallback, useContext, useState, type ReactNode } from 'react';

interface T { id: number; kind: 'ok' | 'err' | 'info'; text: string; items?: string[] }
const Ctx = createContext<{ ok: (t: string) => void; err: (t: string, items?: string[]) => void; info: (t: string) => void }>({ ok: () => {}, err: () => {}, info: () => {} });

export function ToastProvider({ children }: { children: ReactNode }) {
  const [list, setList] = useState<T[]>([]);
  const push = useCallback((kind: T['kind'], text: string, items?: string[]) => {
    const id = Date.now() + Math.random();
    setList((l) => [...l, { id, kind, text, items }]);
    setTimeout(() => setList((l) => l.filter((x) => x.id !== id)), kind === 'err' ? 9000 : 4000);
  }, []);
  return (
    <Ctx.Provider value={{ ok: (t) => push('ok', t), err: (t, i) => push('err', t, i), info: (t) => push('info', t) }}>
      {children}
      <div className="toasts" role="status" aria-live="polite">
        {list.map((t) => (
          <div key={t.id} className={`toast ${t.kind}`} onClick={() => setList((l) => l.filter((x) => x.id !== t.id))}>
            {t.text}
            {t.items?.length ? <ul>{t.items.slice(0, 8).map((i, k) => <li key={k}>{i}</li>)}</ul> : null}
          </div>
        ))}
      </div>
    </Ctx.Provider>
  );
}
export const useToast = () => useContext(Ctx);
